export default __webpack_public_path__ + "static/media/icon-avatar-school.b0089dae.svg";